import styled, { css } from 'styled-components'
import ReactModal from 'react-modal'
import Slider from 'react-slick'

import SearchMall from '../SearchMall/SearchMall'

import media from '../../../services/generateMediaQueries'

import Loader from '../../../assets/img/loader.gif'
import NewSideBarBG from '../../../assets/img/sidebar-bgnew.webp'
import MoreHeaderParticles from '../../../assets/img/more-header-particles.svg'

export const StyledReactModal = styled(ReactModal)`
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  background: rgb(255, 255, 255);
  outline: none;
  width: 100%;
  height: 100%;
  max-width: 375px;
  transition: all var(--animation-duration) var(--animation-easing);

  &.ReactModal__Content {
    &--after-open {
      opacity: 1;
      transition: all var(--animation-duration) var(--animation-easing);
    }

    &--before-close {
      opacity: 0;
      transition: all calc(var(--animation-duration) / 2)
        var(--animation-easing);
    }
  }

  ${media.lessThan('xsmall')`
  border-radius: 0;
  max-width: unset;
`}
`

export const SearchContentContainer = styled.div`
display: flex;
flex-direction: column;
position: relative;
width: 100%;
height: 100%;

&::before {
  content: ' ';
  display: block;
  min-height: 200px;
  background-color: var(--color-primary);
  background-image: url('${NewSideBarBG}'), linear-gradient(var(--color-primary), var(--color-primary));
  background-position: right top;
  background-repeat: no-repeat;
  background-size: 100%;
}
`

export const Header = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  flex: 0 0 auto;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  min-height: 87px;
  font-size: 0.7rem;
  z-index: 100;

  ${props =>
    props.hasScrolled &&
    css`
  background: url('${MoreHeaderParticles}'), linear-gradient(var(--color-primary), var(--color-primary));
  background-repeat: no-repeat;
  background-position: right top;
`}
`

export const CloseIcon = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 2rem;
  cursor: pointer;
  font-size: 1.5rem;
  margin-left: 20px !important;
  margin-right: 20px !important;
  color: var(--color-fg-light);
  background: rgba(255, 255, 255, 0.5);
  z-index: 1;

  & > svg {
    position: relative;
    color: #ffffff;
  }
`

export const Title = styled.h1`
  font-family: var(--font-family-ayala-display-sans);
  flex: 1;
  padding: 20px 0;
  margin: 0;
  margin-left: 60px;
  color: #ffffff;
  font-size: 1.125rem;
  font-weight: var(--font-weight-boldest);
  text-transform: uppercase;
  text-align: center;
`

export const SearchFieldsContainer = styled.div`
  margin: 0 1.25rem;
  background: white;
`

export const OffsetInput = styled.div`
  margin-top: -0.75rem;
`

export const Label = styled.div`
  font-size: 0.75rem;
  font-weight: var(--font-weight-bold);
  letter-spacing: var(--letter-spacing-narrow);
  text-transform: uppercase;
  color: var(--color-primary);
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin: 1rem 1.25rem;
  margin-top: 0;
  margin-bottom: 1rem;
`

export const SearchResults = styled.ul`
  margin: 0;
  margin-top: 1rem;
  padding: 0;
  list-style: none;
  flex: 1;
  overflow: auto;
`

export const ResultEvents = styled.div`
width: 100%;
overflow: auto;
white-space: nowrap;

&::-webkit-scrollbar {
  width: 1em;
}
}
`

export const ResultEventContainer = styled.div`
  display: inline-block;

  /* &:last-child {
  margin-right: 1.25rem;
} */
`

export const ResultEvent = styled.li`
  width: 300px;
  display: flex;
  margin: 0 0 1rem 1.25rem;
  padding: 1rem;
  border: 1px solid #f1f1f1;
  border-radius: 6px;
  background-color: var(--color-bg-form);
  align-items: center;
  max-height: 330px;
  overflow: auto;
  user-select: none;
  cursor: pointer;
`

export const ResultEventText = styled.div`
  width: calc(100% - 72px - 1.25rem);
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`

export const SearchEventTitle = styled.h3`
  font-size: 0.9375rem;
  font-weight: var(--font-weight-bold);
  letter-spacing: var(--letter-spacing-narrow);
  margin: 0;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`
export const EventSubtitle = styled.p`
  font-size: 0.75rem;
  margin: 0;
  color: #9b9b9b;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const EventImage = styled.img`
  width: 72px;
  height: 72px;
  object-fit: cover;
  border-radius: 4px;
  margin-right: 1rem;
`

export const StyledSlider = styled(Slider)`
  .slick-slide {
    outline: none !important;
  }

  .slick-slide:focus {
    outline: none;
  }
`

export const Result = styled.li`
  display: flex;
  padding: 1rem 1.25rem;
  border-top: 1px solid #f1f1f1;
  align-items: center;
  max-height: 330px;
  overflow: auto;
  user-select: none;
  cursor: pointer;

  &:last-child {
    border-bottom: 1px solid #f1f1f1;
  }
`

export const ResultText = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`

export const SearchTitle = styled.h3`
  font-size: 0.9375rem;
  font-weight: var(--font-weight-bold);
  letter-spacing: var(--letter-spacing-narrow);
  margin: 0;
`

export const Subtitle = styled.p`
  font-size: 0.75rem;
  margin: 0;
  color: #9b9b9b;
  // width: 100%;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 20rem;

  ${media.lessThan('small')`
width: 22.5rem;`}
`

export const LabelText = styled.p`
  margin: 0;
`

export const ClearSearch = styled.a`
  text-transform: uppercase;
  font-size: 0.75rem;
  font-weight: var(--font-weight-bold);
  cursor: pointer;
  user-select: none;
  background: #eaf1f9;
  padding: 5px 10px;
  border-radius: 3px;
`

export const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const StyledLoader = styled.img.attrs({ src: Loader })`
  max-height: 30px;
`

export const StyledSearchMall = styled(SearchMall)`
  display: ${props => (props.show ? 'flex' : 'none')} !important;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 200;
`

export const PositionErrorWrapper = styled.div`
  padding: 0 1.25rem;
`

export const PositionError = styled.div`
  padding: 0.5rem 1rem;
  opacity: 0.5;
  position: relative;
  display: flex;
  align-items: center;
  ::before {
    background-color: currentColor;
    content: '';
    display: block;
    opacity: 0.25;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 0.25rem;
  }
`

export const PositionErrorIcon = styled.span`
  flex-shrink: 1;
  margin-right: 0.5rem;
  font-size: 2rem;
  line-height: 0;
`

export const PositionErrorText = styled.span`
  flex: auto;
  font-size: 0.75rem;
  line-height: 1.25;
`

export const InputHidden = styled.input.attrs({ type: 'hidden' })``

export const NoResults = styled.div`
  margin: 0 1.25rem;
  padding: 0.75rem;
  background: #eef0f5;
  color: #9b9b9b;
  border-radius: var(--border-radius-small);
  font-size: 0.75rem;
  letter-spacing: var(--letter-spacing-narrow);
`

export const RecentSearchWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 0 0.875rem;
  margin-bottom: 1rem;
`

export const RecentSearchItem = styled.span`
  cursor: pointer;
  color: #9b9b9b;
  font-size: 0.875rem;
  font-weight: var(--font-weight-bold);
  letter-spacing: 0.47px;
  padding: 9px 19px;
  margin: 5px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
  background: #f2f2f2;
  border-radius: 3rem;
`
